export const getPusherKey = (state) => {
  return state.VNPusher.get('key')
}

export const getPusherCluster = (state) => {
  return state.VNPusher.get('cluster')
}
